<template>
  <div class="home-item">
    <h2 class="item-heading">{{parse(listItem).heading}}</h2>
    <div v-html="parse(listItem).text"></div>

    <div class="item-controls">
      <div
        class="item-control"
        @click="editItem(listItem)">
        <Sprite class="edit-icon" name="edit"/>
        <span>Edit Text</span>
      </div>

      <div
        class="item-control"
        @click="nextItem">
        <Sprite class="continue-icon" name="tick"/>
        <span>Continue</span>
      </div>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import parseComponent from '@/mixins/parseComponent'

import Sprite from '@/components/Sprite'

export default {
  name: 'home-item',

  mixins: [page, parseComponent],

  components: {
    Sprite
  },

  props: [
    'companyId', 'siteId', 'pageId', 'listId', 'listItemId', 'index', 'listItem', 'totalItems'
  ],

  computed: {
    isLastItem() {
      return this.index === this.totalItems
    }
  },

  methods: {
    editItem(item) {
      this.$router.push({
        name: 'editHomeContent',
        params: {
          pageId: this.pageId,
          listId: this.listId,
          listItemId: item.id
        }
      })
    },

    nextItem() {
      if (this.isLastItem) {
        this.$router.push({
          name: 'otherContent',
          params: {
            companyId: this.companyId,
            siteId: this.siteId
          }
        })
      } else {
        ++this.index

        this.$router.push({
          name: 'showHomeContent',
          params: {
            companyId: this.companyId,
            siteId: this.siteId,
            pageId: this.pageId,
            listId: this.listId,
            index: this.index,
            listItemId: this.listItem.id
          }
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.item-controls
  margin-bottom: -95px
  display: flex
  align-items: center
  justify-content: center

  .sprite
    width: 25px
    height: 25px
    margin-bottom: 8px

    &.edit-icon
      fill: #d79960

    &.continue-icon
      fill: #61d97c

  .item-control
    cursor: pointer
    background: #fff
    color: rgba(0, 0, 0, 0.25)
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    font-size: 7px
    font-weight: bold
    text-transform: uppercase
    white-space: nowrap
    width: 75px
    height: 75px
    border-radius: 50%
    box-shadow: $box-shadow
    margin: 0 $gap-large
    transition: transform .2s ease-in-out

    &:hover
      transform: scale(1.1)
</style>
